import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { applyActionCode } from 'firebase/auth';
import { auth } from '../firebase';
import LoadingSpinner from './LoadingSpinner';
import './VerifyEmail.css';

function VerifyEmail() {
  const navigate = useNavigate();
  const location = useLocation();
  const [message, setMessage] = useState('メールアドレスを確認しています...');
  const [error, setError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [countdown, setCountdown] = useState(3);
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const params = new URLSearchParams(location.search);
    const mode = params.get('mode');
    const oobCode = params.get('oobCode');

    if (mode === 'verifyEmail' && oobCode) {
      applyActionCode(auth, oobCode)
        .then(() => {
          setIsSuccess(true);
          setMessage('メールアドレスの確認が完了しました。');
        })
        .catch((err) => {
          console.error('Firebase verification error:', err);
          setError(true);
          setMessage(`エラーが発生しました: ${err.message}`);
        });
    } else {
      setError(true);
      setMessage('無効なリンクです。');
    }
  }, [location]);

  const handleRedirect = useCallback(() => {
    const destination = isSuccess ? '/?status=verified' : '/?error=verification_failed';
    window.location.href = "https://example.com";
    navigate(destination, { replace: true });
  }, [isSuccess, navigate]);

  useEffect(() => {
    if (isSuccess || error) {
      if (countdown > 0) {
        const timer = setTimeout(() => setCountdown(prev => prev - 1), 1000);
        return () => clearTimeout(timer);
      } else {
        handleRedirect();
      }
    }
  }, [countdown, isSuccess, error, handleRedirect]);

  if (!isSuccess && !error) {
    return (
      <div className="verify-page-container">
        <LoadingSpinner message={message} />
      </div>
    );
  }

  return (
    <div className="verify-page-container">
      <div className={`verify-card ${error ? 'error' : ''}`}>
        <p className="message">{message}</p>
        <p className="countdown">
          {countdown > 0 ? `${countdown}秒後にリダイレクトします...` : 'リダイレクトしています...'}
        </p>
        <button onClick={handleRedirect} className="redirect-button">
          すぐにリダイレクトする
        </button>
      </div>
    </div>
  );
}

export default VerifyEmail;
